import {
    WagonStayDuration,
    WagonStayDurationType,
} from '@wagon-stays-lib/wagon-stays.model'

export function determineStayDuration(
    durationInMinutes: number
): WagonStayDuration {
    const durationInHours = durationInMinutes / 60
    const durationInDays = Math.floor(durationInHours / 24) // hours / 24h, cut down to full days
    const remainingDurationHours = durationInHours - durationInDays * 24 // hours that are not already displayed as full days
    const durationInFullHours = Math.floor(remainingDurationHours) // hours cut down to full hours
    const remainder = durationInHours % 24 // export function minutes that are smaller than a full hour as a partial of an hour. e.g. 30min would return 0,5
    const durationMinutes = Math.floor(60 * remainder) // convert remainder to minutes
    const isSmallerThanOneHour =
        durationInDays === 0 && remainingDurationHours < 1
    const isSmallerThanOneDay =
        durationInDays === 0 &&
        remainingDurationHours < 24 &&
        !isSmallerThanOneHour
    return {
        days: durationInDays,
        hours: durationInFullHours,
        minutes: isSmallerThanOneHour ? durationMinutes : 0,
        durationType: isSmallerThanOneHour
            ? WagonStayDurationType.SMALLER_THAN_1h
            : isSmallerThanOneDay
              ? WagonStayDurationType.SMALLER_THAN_24h
              : WagonStayDurationType.LARGER_THAN_24h,
    }
}
